module.exports = __webpack_public_path__ + "img/winerackdog14.dc878fd8.jpg";